import React from 'react';
import StatusBadge from '@/components/ui/StatusBadge';

const capFirst = (s) => (s && s.length ? s.charAt(0).toUpperCase() + s.slice(1).toLowerCase() : '—');
const formatDate = (val) => (val ? String(val).slice(0, 10) : '—');

export const getLeaveColumns = ({ openPanel }) => [
    {
        title: 'Employee',
        dataIndex: 'userName',
        key: 'userName',
        render: (val, record) => (
            <span
                style={{ fontWeight: 600, color: 'var(--ant-color-primary, #1890ff)', cursor: 'pointer' }}
                onClick={() => openPanel(record.id)}
            >
                {val || '—'}
            </span>
        ),
    },
    { title: 'Email', dataIndex: 'userEmail', key: 'userEmail' },
    {
        title: 'Start',
        dataIndex: 'startDate',
        key: 'startDate',
        width: 110,
        render: (val) => formatDate(val),
    },
    {
        title: 'End',
        dataIndex: 'endDate',
        key: 'endDate',
        width: 110,
        render: (val) => formatDate(val),
    },
    {
        title: 'Type',
        dataIndex: 'type',
        key: 'type',
        width: 100,
        render: (val) => capFirst(val || '—'),
    },
    {
        title: 'Status',
        dataIndex: 'status',
        key: 'status',
        width: 100,
        render: (val) => <StatusBadge status={val} />,
    },
];
